import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {changeAppointmentStatus, getAllAppointment, getAppointmentcalender, getconsentform} from "../../../store/crm/appointment";
import toast from "react-hot-toast";
import AppointmentDetails from "../appointment/appointment-details/appointmentDetails";
import {
    Avatar, Box, Button, Chip, Divider, Grid, IconButton,
    Link, Tooltip, Typography
} from "@mui/material";
import AppointmentStaffcalender from '../appointment/AppointmentStaffStatus/appointstaffCalendar';
import SetEmailCalenderModal from '../../../components/modal/SetEmailCalenderModal';
import Customcolorbtn from '../../../components/custom-button/customeColorCalender';
import AppointmentCalender from '../../../components/card-appointment/AppointmentCalender';
import TreatmentFormButtonCalendar from '../../../components/card-appointment/treatmentCalenderForm';
import Waveloading from '../../loading/Waveloading';
import CalenderNoteModal from '../../../components/modal/CalenderNotes';
import {FormLinkData} from '../../../store/user/chart-form';
import {MySwal} from '../../../services/utills';
import {handleEditReschedule, ribbonwrapper} from "../../../components/card-appointment/CardAppointment";
import {useNavigate} from "react-router";
import ribbon from "../../../assets/images/ribbon.svg";
import redRibbon from "../../../assets/images/red-badg.svg";
import ribbonorange from "../../../assets/images/ribbon-orange.svg";
import {PlayArrow} from "@mui/icons-material";
import AttachEmailIcon from '@mui/icons-material/AttachEmail';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import LogoutIcon from '@mui/icons-material/Logout';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import DescriptionIcon from '@mui/icons-material/Description';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PersonIcon from '@mui/icons-material/Person';
import AppointmentDetailscalender from '../appointment/appointment-details/AppoinmnetDetail calender';
import BrandAvatar from '../../../components/avatar/BrandAvatar';

export const boxwrapper = {border: "1px solid black", padding: "10px", height: "13vh", alignItems: "center", textAlign: "center", borderRadius: "8px"};
export const box = {display: "block", margin: "15px auto"};

const statusColorMapping = {
    Pending: '#56CCF2',
    Confirmed: '#323681',
    UnConfirmedPending: '#56CCF2',
    ConfirmedPending: '#323681',
    CheckIn: '#F2C94C',
    Completed: '#219653',
    CheckOut: '#219653',
    Canceled: '#EB5757',
    Refund: '#EB5757',
    NoShow: '#9A9797',
    PendingConfirmation: '#56CCF2',
};

const SidebarIcon = ({title, icon, onClick, color = '#A72C68', active = false}) => (
    <Tooltip title={title} placement="left" arrow>
        <IconButton
            onClick={onClick}
            sx={{
                width: { xs: 34, sm: 38, md: 42 }, height: { xs: 34, sm: 38, md: 42 },
                borderRadius: '10px',
                background: active ? color : '#FAEFF5',
                color: active ? '#fff' : '#A72C68',
                border: active ? `1px solid ${color}` : '1px solid #F0CDDB',
                '& svg': { fontSize: { xs: 15, sm: 17, md: 19 } },
                '&:hover': {background: color, color: '#fff', borderColor: color},
                transition: 'all 0.15s ease',
            }}
        >
            {icon}
        </IconButton>
    </Tooltip>
);

const InfoItem = ({label, value}) => (
    <Box>
        <Typography sx={{fontSize: '11px', color: '#1a1a2e', fontWeight: 600, letterSpacing: '0.5px', mb: '2px', textTransform: 'uppercase'}}>
            {label}
        </Typography>
        <Typography sx={{fontSize: '13px', color: '#111827', fontWeight: 500, wordBreak: 'break-word'}}>
            {value || '—'}
        </Typography>
    </Box>
);

const CalenderAppointmentDetail = ({appointment_id, fetchCalenderBookings, onRescheduleSuccess, onClose, onClientFormOpen, clientFormActive, onAppointmentLoaded, onNotesOpen, notesActive, onOpenPanel, activeSidePanel, onInvoiceClick}) => {
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const scrollableRef = useRef(null);

    useEffect(() => {
        const el = scrollableRef.current;
        if (el) {
            el.addEventListener('keydown', (e) => { if (e.key === 'ArrowDown') el.scrollBy(0, 10); });
            el.tabIndex = '0';
            el.style.outline = 'none';
        }
    }, []);

    const crmAppointmentStore = useSelector((state) => state?.crmAppointmentStore);
    const {appointmentDetail = [], consentform = []} = crmAppointmentStore;

    useEffect(() => {
        if (!appointment_id) return;
        (async () => {
            setLoading(true);
            try {
                const [apptResult] = await Promise.all([
                    dispatch(getAppointmentcalender(appointment_id)),
                    dispatch(getconsentform(appointment_id)),
                ]);
                if (apptResult?.payload) onAppointmentLoaded?.(apptResult.payload);
            } finally {
                setLoading(false);
            }
        })();
    }, [appointment_id]);

    const handleRowClick = async (userid, formid) => {
        setLoading(true);
        await dispatch(FormLinkData({user_id: userid, form_id: formid}));
        setLoading(false);
    };

    const handleDirectStatusChange = async (statusValue, successMessage) => {
        if (!appointmentDetail?.id) return;
        setLoading(true);
        try {
            const res = await dispatch(changeAppointmentStatus({
                appointment_id: appointmentDetail.id,
                status: statusValue,
            }));
            if (res?.payload?.success === 'true') {
                await Promise.all([
                    dispatch(getAppointmentcalender(appointmentDetail.id)),
                    dispatch(getAllAppointment()),
                ]);
                if (fetchCalenderBookings) await fetchCalenderBookings();
                if (onRescheduleSuccess) await onRescheduleSuccess();
                toast.success(successMessage);
            }
        } finally {
            setLoading(false);
        }
    };

    const status = appointmentDetail?.status;
    const statusColor = statusColorMapping[status] || '#9A9797';
    const isActive = status !== 'Completed' && status !== 'Canceled' && status !== 'Void';

    const getInitials = (name) => {
        if (!name) return '?';
        return name.split(' ').filter(Boolean).map(n => n[0]).join('').toUpperCase().slice(0, 2);
    };

    return (
        <Box ref={scrollableRef} sx={{display: 'flex', height: '100vh', overflow: 'hidden', background: '#fff', position: 'relative'}}>

                {/* Left Sidebar — icon buttons only, hover shows name (hidden on mobile) */}
            <Box sx={{
                width: { sm: '46px', md: '58px' }, flexShrink: 0,
                background: '#FAEFF5',
                borderRight: '1px solid #F0CDDB',
                display: { xs: 'none', sm: 'flex' }, flexDirection: 'column', alignItems: 'center',
                pt: { sm: 2 }, pb: { sm: 2 }, gap: { sm: '6px' },
                overflowY: 'auto',
                zIndex: 3,
                '&::-webkit-scrollbar': {width: 0},
            }}>
                {status !== 'Completed' && status !== 'Canceled' && (
                    <SidebarIcon title="Assign Staff" active={activeSidePanel?.type === 'staff' && !activeSidePanel?.config?.label} icon={<PersonAddIcon sx={{fontSize: 19}} />} onClick={() => onOpenPanel?.('staff', {})} color="#323681" />
                )}
                {(status === 'Pending' || status === 'Confirmed' || status === 'No Show') && (
                    <SidebarIcon title="Check In" active={activeSidePanel?.config?.value === 'CheckIn'} icon={<CheckCircleOutlineIcon sx={{fontSize: 19}} />} onClick={() => onOpenPanel?.('staff', {label:'Check-In', value:'CheckIn', mainColor:'#F2C94C'})} color="#d97706" />
                )}
                {status === 'CheckIn' && (
                    <SidebarIcon title="Check Out" active={activeSidePanel?.config?.value === 'CheckOut'} icon={<LogoutIcon sx={{fontSize: 19}} />} onClick={() => onOpenPanel?.('staff', {label:'Check-Out', value:'CheckOut', mainColor:'#F2C94C'})} color="#d97706" />
                )}
                {isActive && (
                    <SidebarIcon title="Reschedule" active={activeSidePanel?.type === 'reschedule'} icon={<CalendarMonthIcon sx={{fontSize: 19}} />} onClick={() => onOpenPanel?.('reschedule')} color="#f59e0b" />
                )}
                {isActive && (
                    <SidebarIcon title="Edit Appointment" icon={<EditIcon sx={{fontSize: 19}} />} onClick={() => handleEditReschedule(navigate, appointmentDetail)} color="#0ea5e9" />
                )}
                {isActive && (
                    <SidebarIcon title="Cancel / Refund" icon={<CloseIcon sx={{fontSize: 19}} />} onClick={() => handleDirectStatusChange('Canceled', 'Cancellation & refund processed successfully!')} color="#ef4444" />
                )}
                {status !== 'Completed' && status !== 'No Show' && status !== 'Canceled' && (
                    <SidebarIcon title="No Show" active={activeSidePanel?.config?.value === 'No Show'} icon={<PersonOffIcon sx={{fontSize: 19}} />} onClick={() => onOpenPanel?.('staff', {label:'No Show', value:'No Show', mainColor:'#9A9797'})} color="#6b7280" />
                )}
                {status === 'Pending' && (
                    <SidebarIcon title="Confirm Appointment" icon={<HowToRegIcon sx={{fontSize: 19}} />} onClick={() => handleDirectStatusChange('Confirmed', 'Appointment confirmed successfully!')} color="#16a34a" />
                )}

                <Divider flexItem sx={{width: '60%', borderColor: '#F0CDDB', my: '4px'}} />

                <SidebarIcon title="Client Form" active={clientFormActive} icon={<DescriptionIcon sx={{fontSize: 19}} />} onClick={() => onClientFormOpen?.()} color="#7c3aed" />
                <SidebarIcon title="Send Email" active={activeSidePanel?.type === 'email'} icon={<EmailOutlinedIcon sx={{fontSize: 19}} />} onClick={() => onOpenPanel?.('email')} color="#16a34a" />
                <SidebarIcon title="Patient Records" active={notesActive} icon={<AssignmentIndIcon sx={{fontSize: 19}} />} onClick={() => onNotesOpen?.(appointmentDetail)} color="#db2777" />
                <SidebarIcon title="Photos" active={activeSidePanel?.type === 'photos'} icon={<PhotoLibraryIcon sx={{fontSize: 19}} />} onClick={() => onOpenPanel?.('photos')} color="#0ea5e9" />
            </Box>

            {/* Appointment Detail */}
            <Box sx={{flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column', background: '#fff'}}>
                    {/* Header */}
                    <Box sx={{px: { xs: 1.25, md: 2.5 }, py: 1.5, borderBottom: '1px solid #f3f4f6', background: '#fff', display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0}}>
                        <IconButton
                            size="small"
                            onClick={onClose}
                            sx={{
                                display: { xs: 'inline-flex', sm: 'none' },
                                color: '#A72C68', borderRadius: '8px',
                                background: '#FAEFF5', border: '1px solid #F0CDDB',
                                mr: 0.5,
                                '&:hover': { background: '#F0CDDB' },
                            }}
                        >
                            <ArrowBackIcon sx={{ fontSize: 17 }} />
                        </IconButton>
                        <Box sx={{flex: 1, minWidth: 0}}>
                            {loading ? null : (
                                <Box sx={{display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap'}}>
                                    <Typography sx={{fontSize: '13px', fontWeight: 700, color: '#111827'}}>
                                        Booking ID #{appointmentDetail?.id || '—'}
                                    </Typography>
                                    <Typography sx={{fontSize: '12px', color: '#9ca3af'}}>·</Typography>
                                    <Chip
                                        label={appointmentDetail?.type || 'MANUAL APPOINTMENT'}
                                        size="small"
                                        sx={{fontSize: '10px', fontWeight: 600, height: '20px', background: '#f3f4f6', color: '#6b7280', borderRadius: '4px', letterSpacing: '0.2px'}}
                                    />
                                    {status && (
                                        <Chip
                                            label={status.toUpperCase()}
                                            size="small"
                                            sx={{fontSize: '10px', fontWeight: 700, height: '20px', background: statusColor + '1a', color: statusColor, borderRadius: '4px'}}
                                        />
                                    )}
                                </Box>
                            )}
                        </Box>
                        {isActive && (
                            <Tooltip title="Edit Appointment" placement="bottom">
                                <IconButton size="small" onClick={() => handleEditReschedule(navigate, appointmentDetail)} sx={{color: '#2D9CDB', borderRadius: '8px', '&:hover': {color: '#2D9CDB', background: '#f0f9ff'}}}>
                                    <EditIcon sx={{fontSize: 17}} />
                                </IconButton>
                            </Tooltip>
                        )}
                        <Tooltip title="Close" placement="bottom">
                            <IconButton size="small" onClick={onClose} sx={{color: '#EB5757', borderRadius: '8px', '&:hover': {color: '#EB5757', background: '#fef2f2'}}}>
                                <CloseIcon sx={{fontSize: 17}} />
                            </IconButton>
                        </Tooltip>
                    </Box>

                    {/* Scrollable Body */}
                    <Box sx={{flex: 1, overflowY: 'auto', background: '#f9fafb', position: 'relative', '&::-webkit-scrollbar': {width: '4px'}, '&::-webkit-scrollbar-thumb': {borderRadius: '4px', background: 'rgba(0,0,0,0.1)'}}}>
                        {loading && <Waveloading cover />}
                        {(
                            <Box>
                                {/* Quick Actions — outlined, status-colored */}
                                <Box sx={{mx: { xs: 1, md: 2 }, mt: 2, mb: 1.5, display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: { xs: 1, md: 1.25 }}}>
                                    {(() => {
                                        const qaBaseSx = {
                                            width: '100%',
                                            minWidth: 0,
                                            height: 44,
                                            px: 2,
                                            textTransform: 'none',
                                            borderRadius: '12px',
                                            fontSize: '13px',
                                            fontWeight: 700,
                                            letterSpacing: '0.1px',
                                            whiteSpace: 'nowrap',
                                            background: '#fff',
                                            boxShadow: 'none',
                                            borderStyle: 'solid',
                                            borderWidth: '1.5px',
                                            '& .MuiButton-startIcon': { mr: 0.75 },
                                            '& .MuiButton-startIcon svg': { fontSize: '17px !important' },
                                            '&:hover': { background: '#fff', boxShadow: '0 4px 10px rgba(15, 23, 42, 0.06)' },
                                            '@media (max-width: 360px)': {
                                                height: 'auto',
                                                minHeight: 44,
                                                px: 1,
                                                py: 0.75,
                                                fontSize: '12px',
                                                lineHeight: 1.2,
                                                whiteSpace: 'normal',
                                                textAlign: 'left',
                                                '& .MuiButton-startIcon': { mr: 0.5, ml: 0 },
                                                '& .MuiButton-startIcon svg': { fontSize: '16px !important' },
                                            },
                                        };
                                        const mkSx = (color, hoverBg) => ({
                                            color,
                                            borderColor: color,
                                            '&:hover': { background: hoverBg, borderColor: color, color },
                                        });

                                        const buttons = [];
                                        if (status === 'Pending') buttons.push({
                                            key: 'confirm',
                                            label: 'Confirm Appointment',
                                            icon: <HowToRegIcon />,
                                            onClick: () => handleDirectStatusChange('Confirmed', 'Appointment confirmed successfully!'),
                                            sx: mkSx('#16a34a', '#DCFCE7'),
                                        });
                                        if (status === 'Pending' || status === 'Confirmed' || status === 'No Show') buttons.push({
                                            key: 'checkin',
                                            label: 'Check In',
                                            icon: <CheckCircleOutlineIcon />,
                                            onClick: () => onOpenPanel?.('staff', { label: 'Check-In', value: 'CheckIn', mainColor: '#F2C94C' }),
                                            sx: mkSx('#d97706', '#FEF3C7'),
                                        });
                                        if (status === 'CheckIn') buttons.push({
                                            key: 'checkout',
                                            label: 'Check Out',
                                            icon: <LogoutIcon />,
                                            onClick: () => onOpenPanel?.('staff', { label: 'Check-Out', value: 'CheckOut', mainColor: '#F2C94C' }),
                                            sx: mkSx('#d97706', '#FEF3C7'),
                                        });
                                        if (isActive) buttons.push({
                                            key: 'reschedule',
                                            label: 'Reschedule',
                                            icon: <CalendarMonthIcon />,
                                            onClick: () => onOpenPanel?.('reschedule'),
                                            sx: mkSx('#7c3aed', '#F3E8FF'),
                                        });
                                        if (isActive) buttons.push({
                                            key: 'edit',
                                            label: 'Edit',
                                            icon: <EditIcon />,
                                            onClick: () => handleEditReschedule(navigate, appointmentDetail),
                                            sx: mkSx('#0ea5e9', '#E0F2FE'),
                                        });
                                        if (isActive) buttons.push({
                                            key: 'cancel',
                                            label: 'Cancel / Refund',
                                            icon: <CloseIcon />,
                                            onClick: () => handleDirectStatusChange('Canceled', 'Cancellation & refund processed successfully!'),
                                            sx: mkSx('#ef4444', '#FEE2E2'),
                                        });
                                        buttons.push({
                                            key: 'records',
                                            label: 'Patient Records',
                                            icon: <AssignmentIndIcon />,
                                            onClick: () => onNotesOpen?.(appointmentDetail),
                                            sx: mkSx('#db2777', '#FCE7F3'),
                                        });

                                        return buttons.map(b => (
                                            <Tooltip key={b.key} title={b.label} placement="top" arrow>
                                                <Button
                                                    onClick={b.onClick}
                                                    startIcon={b.icon}
                                                    sx={{ ...qaBaseSx, ...b.sx }}
                                                >
                                                    {b.label}
                                                </Button>
                                            </Tooltip>
                                        ));
                                    })()}
                                </Box>

                                {/* Mobile-only action icons row (replaces left sidebar on mobile) */}
                                <Box sx={{
                                    display: { xs: 'flex', sm: 'none' },
                                    mx: 1, mb: 1.5,
                                    p: 1,
                                    gap: 0.75,
                                    overflowX: 'auto',
                                    background: '#fff',
                                    border: '1px solid #F1F2F6',
                                    borderRadius: '12px',
                                    '&::-webkit-scrollbar': { height: 0 },
                                }}>
                                    {(() => {
                                        const iconBtnSx = (c) => ({
                                            flexShrink: 0,
                                            width: 38, height: 38,
                                            borderRadius: '10px',
                                            background: '#fff',
                                            border: `1.5px solid ${c}`,
                                            color: c,
                                            '& svg': { fontSize: 18 },
                                            '&:hover': { background: c + '14' },
                                        });
                                        const items = [];
                                        if (status !== 'Completed' && status !== 'Canceled') items.push({
                                            key: 'm-staff', title: 'Assign Staff',
                                            icon: <PersonAddIcon />, color: '#323681',
                                            onClick: () => onOpenPanel?.('staff', {}),
                                        });
                                        if (status === 'Pending') items.push({
                                            key: 'm-confirm', title: 'Confirm Appointment',
                                            icon: <HowToRegIcon />, color: '#16a34a',
                                            onClick: () => handleDirectStatusChange('Confirmed', 'Appointment confirmed successfully!'),
                                        });
                                        if (status === 'Pending' || status === 'Confirmed' || status === 'No Show') items.push({
                                            key: 'm-checkin', title: 'Check In',
                                            icon: <CheckCircleOutlineIcon />, color: '#d97706',
                                            onClick: () => onOpenPanel?.('staff', { label: 'Check-In', value: 'CheckIn', mainColor: '#F2C94C' }),
                                        });
                                        if (status === 'CheckIn') items.push({
                                            key: 'm-checkout', title: 'Check Out',
                                            icon: <LogoutIcon />, color: '#d97706',
                                            onClick: () => onOpenPanel?.('staff', { label: 'Check-Out', value: 'CheckOut', mainColor: '#F2C94C' }),
                                        });
                                        if (isActive) items.push({
                                            key: 'm-resched', title: 'Reschedule',
                                            icon: <CalendarMonthIcon />, color: '#7c3aed',
                                            onClick: () => onOpenPanel?.('reschedule'),
                                        });
                                        if (isActive) items.push({
                                            key: 'm-edit', title: 'Edit Appointment',
                                            icon: <EditIcon />, color: '#0ea5e9',
                                            onClick: () => handleEditReschedule(navigate, appointmentDetail),
                                        });
                                        if (isActive) items.push({
                                            key: 'm-cancel', title: 'Cancel / Refund',
                                            icon: <CloseIcon />, color: '#ef4444',
                                            onClick: () => handleDirectStatusChange('Canceled', 'Cancellation & refund processed successfully!'),
                                        });
                                        if (status !== 'Completed' && status !== 'No Show' && status !== 'Canceled') items.push({
                                            key: 'm-noshow', title: 'No Show',
                                            icon: <PersonOffIcon />, color: '#6b7280',
                                            onClick: () => onOpenPanel?.('staff', { label: 'No Show', value: 'No Show', mainColor: '#9A9797' }),
                                        });
                                        items.push({
                                            key: 'm-clientform', title: 'Client Form',
                                            icon: <DescriptionIcon />, color: '#7c3aed',
                                            onClick: () => onClientFormOpen?.(),
                                        });
                                        items.push({
                                            key: 'm-email', title: 'Send Email',
                                            icon: <EmailOutlinedIcon />, color: '#db2777',
                                            onClick: () => onOpenPanel?.('email'),
                                        });
                                        items.push({
                                            key: 'm-notes', title: 'Patient Records',
                                            icon: <AssignmentIndIcon />, color: '#0d9488',
                                            onClick: () => onNotesOpen?.(appointmentDetail),
                                        });
                                        items.push({
                                            key: 'm-photos', title: 'Photos',
                                            icon: <PhotoLibraryIcon />, color: '#0ea5e9',
                                            onClick: () => onOpenPanel?.('photos'),
                                        });

                                        return items.map(it => (
                                            <Tooltip key={it.key} title={it.title} placement="top" arrow>
                                                <IconButton onClick={it.onClick} sx={iconBtnSx(it.color)}>
                                                    {it.icon}
                                                </IconButton>
                                            </Tooltip>
                                        ));
                                    })()}
                                </Box>

                                {/* Patient Card */}
                                <Box sx={{mx: 2, mt: 0, mb: 1.5, p: 2, background: '#fff', borderRadius: '12px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)'}}>
                                    <Box sx={{display: 'flex', alignItems: 'center', gap: 2}}>
                                        <BrandAvatar
                                            name={appointmentDetail?.customer?.name}
                                            src={appointmentDetail?.customer?.profile_image}
                                            size={48}
                                            sx={{flexShrink: 0}}
                                        />
                                        <Box sx={{flex: 1, minWidth: 0}}>
                                            <Typography sx={{fontSize: '10px', color: '#1a1a2e', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px', mb: '2px'}}>Patient Name</Typography>
                                            <Typography
                                                sx={{fontSize: '15px', fontWeight: 700, color: '#111827', cursor: 'pointer', textTransform: 'capitalize', '&:hover': {color: '#A72C68'}}}
                                                onClick={() => navigate(`/crm/customer-relationship-management`, {state: {value: appointmentDetail?.customer?.name}})}
                                            >
                                                {appointmentDetail?.customer?.name || '—'}
                                            </Typography>
                                            <Box sx={{display: 'flex', alignItems: 'center', gap: 1, mt: '4px', flexWrap: 'wrap'}}>
                                                <Box
                                                    sx={{display: 'flex', alignItems: 'center', gap: '5px', px: '10px', py: '3px', borderRadius: '20px', background: statusColor + '18', border: `1px solid ${statusColor}33`, cursor: 'pointer'}}
                                                    // onClick={() => openPanel('staff', {})}
                                                >
                                                    <Box sx={{width: 6, height: 6, borderRadius: '50%', background: statusColor}} />
                                                    <Typography sx={{fontSize: '11px', fontWeight: 600, color: statusColor}}>{status || 'Status'}</Typography>
                                                </Box>
                                                {appointmentDetail?.customer?.customer_batch && (
                                                    <Box sx={ribbonwrapper}>
                                                        {appointmentDetail?.customer?.customer_batch !== 'New User' ? (
                                                            appointmentDetail?.customer?.customer_batch.includes('Expire/Cancel') ? (
                                                                <><img style={{marginTop: '4px', height: '14px'}} src={redRibbon} alt="member" /><Typography style={{color: '#FF0000', fontSize: '11px'}}>{appointmentDetail?.customer?.customer_batch}</Typography></>
                                                            ) : appointmentDetail?.customer?.customer_batch.includes('Declined') ? (
                                                                <><img style={{marginTop: '4px', width: '14px'}} src={ribbonorange} alt="member" /><Typography style={{color: '#f55d0b', fontSize: '11px'}}>{appointmentDetail?.customer?.customer_batch}</Typography></>
                                                            ) : (
                                                                <><img style={{marginTop: '4px', height: '14px'}} src={ribbon} alt="member" /><Typography style={{color: '#219653', fontSize: '11px'}}>{appointmentDetail?.customer?.customer_batch}</Typography></>
                                                            )
                                                        ) : (
                                                            <Typography style={{color: '#09ABF1', fontSize: '11px'}}>{appointmentDetail?.customer?.customer_batch}</Typography>
                                                        )}
                                                    </Box>
                                                )}
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>

                                {/* Treatment / Date / Provider row */}
                                <Box sx={{mx: 2, mb: 1.5, background: '#fff', borderRadius: '12px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', overflow: 'hidden'}}>
                                    <Grid container>
                                        <Grid item xs={12} sm={4} sx={{p: '12px 14px', borderRight: {sm: '1px solid #f3f4f6'}, borderBottom: {xs: '1px solid #f3f4f6', sm: 'none'}}}>
                                            <Box sx={{display: 'flex', alignItems: 'flex-start', gap: '7px'}}>
                                                <MedicalServicesIcon sx={{fontSize: 15, color: '#A72C68', mt: '1px', flexShrink: 0}} />
                                                <Box>
                                                    <Typography sx={{fontSize: '9px', color: '#1a1a2e', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px', mb: '2px'}}>Treatment</Typography>
                                                    <Typography sx={{fontSize: '12px', color: '#111827', fontWeight: 500}}>
                                                        {appointmentDetail?.service?.name || appointmentDetail?.services?.[0]?.name || appointmentDetail?.service_name || '—'}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={4} sx={{p: '12px 14px', borderRight: {sm: '1px solid #f3f4f6'}, borderBottom: {xs: '1px solid #f3f4f6', sm: 'none'}}}>
                                            <Box sx={{display: 'flex', alignItems: 'flex-start', gap: '7px'}}>
                                                <AccessTimeIcon sx={{fontSize: 15, color: '#0ea5e9', mt: '1px', flexShrink: 0}} />
                                                <Box>
                                                    <Typography sx={{fontSize: '9px', color: '#1a1a2e', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px', mb: '2px'}}>Date & Time</Typography>
                                                    <Typography sx={{fontSize: '12px', color: '#111827', fontWeight: 500}}>{appointmentDetail?.date || appointmentDetail?.booking_date || '—'}</Typography>
                                                    {(appointmentDetail?.start_time || appointmentDetail?.time) && (
                                                        <Typography sx={{fontSize: '11px', color: '#1a1a2e', mt: '1px'}}>
                                                            {appointmentDetail?.start_time || appointmentDetail?.time}{appointmentDetail?.end_time ? ` – ${appointmentDetail?.end_time}` : ''}
                                                        </Typography>
                                                    )}
                                                </Box>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={4} sx={{p: '12px 14px'}}>
                                            <Box sx={{display: 'flex', alignItems: 'flex-start', gap: '7px'}}>
                                                <PersonIcon sx={{fontSize: 15, color: '#16a34a', mt: '1px', flexShrink: 0}} />
                                                <Box>
                                                    <Typography sx={{fontSize: '9px', color: '#1a1a2e', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px', mb: '2px'}}>Provider</Typography>
                                                    <Typography sx={{fontSize: '12px', color: '#111827', fontWeight: 500}}>
                                                        {appointmentDetail?.staff?.name || appointmentDetail?.provider?.name || appointmentDetail?.provider_name || '—'}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Box>

                                {/* Payment row */}
                                <Box sx={{mx: { xs: 1, md: 2 }, mb: 1.5, p: { xs: '8px 10px', md: '10px 14px' }, background: '#fff', borderRadius: '12px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap'}}>
                                    <Typography sx={{fontSize: '13px', fontWeight: 700, color: '#1a1a2e'}}>Payment</Typography>
                                    <Chip
                                        label={`Bill #${appointmentDetail?.id || '—'}`}
                                        size="small"
                                        onClick={() => navigate(`/crm/appointment/details/${appointmentDetail?.id}`)}
                                        sx={{fontSize: '11px', height: '20px', background: '#FAEFF5', color: '#A72C68', fontWeight: 600, borderRadius: '5px', cursor: 'pointer', '&:hover': {background: '#F0CDDB'}}}
                                    />
                                    <Chip
                                        label={appointmentDetail?.payment_status || 'UNPAID'}
                                        size="small"
                                        sx={{
                                            fontSize: '11px', height: '20px', fontWeight: 700, borderRadius: '5px',
                                            background: appointmentDetail?.payment_status === 'Paid' ? '#f0fdf4' : '#fff1f2',
                                            color: appointmentDetail?.payment_status === 'Paid' ? '#16a34a' : '#ef4444',
                                        }}
                                    />
                                    <Box sx={{flex: 1}} />
                                    <Typography
                                        sx={{fontSize: '11px', color: '#A72C68', fontWeight: 600, cursor: 'pointer', '&:hover': {textDecoration: 'underline'}}}
                                        onClick={() => navigate(`/crm/appointment/details/${appointmentDetail?.id}`)}
                                    >
                                        View Details →
                                    </Typography>
                                </Box>

                                {/* General Info */}
                                <Box sx={{mx: { xs: 1, md: 2 }, mb: 1.5, p: { xs: 1.25, md: 2 }, background: '#fff', borderRadius: '12px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)'}}>
                                    <Typography sx={{fontSize: '12px', fontWeight: 700, color: '#1a1a2e', mb: 1.5}}>General info</Typography>
                                    <Grid container spacing={2}>
                                        <Grid item xs={6}><InfoItem label="Full Name" value={appointmentDetail?.customer?.name} /></Grid>
                                        <Grid item xs={6}><InfoItem label="Phone Number" value={appointmentDetail?.customer?.phone} /></Grid>
                                        {appointmentDetail?.customer?.dob && <Grid item xs={6}><InfoItem label="Age / DOB" value={appointmentDetail?.customer?.dob} /></Grid>}
                                        <Grid item xs={6}><InfoItem label="Email" value={appointmentDetail?.customer?.email} /></Grid>
                                        {appointmentDetail?.customer?.gender && <Grid item xs={6}><InfoItem label="Gender" value={appointmentDetail?.customer?.gender} /></Grid>}
                                        {appointmentDetail?.customer?.wallet_point && <Grid item xs={6}><InfoItem label="Wallet" value={`$${appointmentDetail?.customer?.wallet_point}`} /></Grid>}
                                        {appointmentDetail?.customer?.address && (
                                            <Grid item xs={12}>
                                                <InfoItem
                                                    label="Address"
                                                    value={
                                                        typeof appointmentDetail?.customer?.address === 'object'
                                                            ? [
                                                                appointmentDetail?.customer?.address?.suite,
                                                                appointmentDetail?.customer?.address?.address,
                                                                appointmentDetail?.customer?.address?.city,
                                                                appointmentDetail?.customer?.address?.state,
                                                                appointmentDetail?.customer?.address?.postal_code,
                                                                appointmentDetail?.customer?.address?.country,
                                                              ].filter(Boolean).join(', ')
                                                            : appointmentDetail?.customer?.address
                                                    }
                                                />
                                            </Grid>
                                        )}
                                    </Grid>
                                </Box>

                                {/* Virtual Consultation */}
                                {appointmentDetail?.type === 'Virtual Consultation' && (
                                    <Box sx={{mx: { xs: 1, md: 2 }, mb: 1.5, p: { xs: 1.25, md: 2 }, background: '#fff', borderRadius: '12px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)'}}>
                                        <Typography sx={{fontSize: '12px', fontWeight: 700, color: '#374151', mb: 1.5}}>Virtual Consultation</Typography>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <Typography sx={{fontSize: '10px', color: '#9ca3af', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px', mb: '2px'}}>Link</Typography>
                                                <Link style={{cursor: 'pointer', fontSize: '12px', wordBreak: 'break-all'}} onClick={() => window.open(`${appointmentDetail?.doxy_link}`, '_blank')}>
                                                    {appointmentDetail?.doxy_link}
                                                </Link>
                                            </Grid>
                                            <Grid item xs={6}><InfoItem label="User" value={appointmentDetail?.doxy_username || 'N/A'} /></Grid>
                                            <Grid item xs={6}><InfoItem label="Password" value={appointmentDetail?.doxy_password || 'N/A'} /></Grid>
                                        </Grid>
                                    </Box>
                                )}

                                {/* Consent Forms */}
                                {consentform?.length > 0 && (
                                    <Box sx={{mx: { xs: 1, md: 2 }, mb: 1.5, p: { xs: 1.25, md: 2 }, background: '#fff', borderRadius: '12px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)'}}>
                                        <Typography sx={{fontSize: '12px', fontWeight: 700, color: '#374151', mb: 1.5}}>Consent Forms</Typography>
                                        {consentform.map((form, index) => (
                                            <Box
                                                key={index}
                                                sx={{
                                                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                                    p: '8px 12px', borderRadius: '8px', mb: '6px',
                                                    border: form.is_submitted ? '1px solid #16a34a' : '1px solid #f3f4f6',
                                                    background: form.is_submitted ? '#f0fdf4' : '#fafafa',
                                                    cursor: 'pointer',
                                                    '&:hover': {background: '#f5f3ff'},
                                                }}
                                                onClick={() => {
                                                    if (form.is_submitted) {
                                                        window.open(`${window?.location?.origin}/crm/${form?.customer_id}/${form?.url}?submit=1&submitted_id=${form?.submitted_id}`);
                                                    } else {
                                                        window.open(`${window?.location?.origin}/crm/${form?.customer_id}/${form?.url}`, '_blank');
                                                    }
                                                }}
                                            >
                                                <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                                                    <PlayArrow sx={{fontSize: '1rem', color: '#9ca3af'}} />
                                                    <Typography sx={{fontSize: '12px', color: '#374151'}}>{form?.name}</Typography>
                                                </Box>
                                                <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                                                    <AttachEmailIcon onClick={(e) => { e.stopPropagation(); handleRowClick(form?.customer_id, form?.treatment_form_id); }} sx={{fontSize: '1rem', color: '#9ca3af', '&:hover': {color: '#A72C68'}}} />
                                                    {form.is_submitted && (
                                                        <>
                                                            <Typography sx={{fontSize: '10px', color: '#6b7280'}}>{form.submitted_time || ''}</Typography>
                                                            <CheckCircleIcon sx={{color: '#16a34a', fontSize: '1.2rem'}} />
                                                        </>
                                                    )}
                                                </Box>
                                            </Box>
                                        ))}
                                    </Box>
                                )}

                                {/* Appointment Details component */}
                                <Box sx={{mx: { xs: 1, md: 2 }, mb: 2, background: '#fff', borderRadius: '12px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', overflow: 'hidden'}}>
                                    <AppointmentDetailscalender appointmentDetails={appointmentDetail} onInvoiceClick={onInvoiceClick} />
                                </Box>
                            </Box>
                        )}
                    </Box>

            </Box>
        </Box>
    );
};

export default CalenderAppointmentDetail;
